import * as React from "react";
import { CheckBox } from "./CheckBox";

export const SingleCheckBox = ({ column, value, handleChange, disabled }) => {
	const handleCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
		handleChange(event.target.checked);
	};

	return (
		<CheckBox
			key={column.name}
			name={column.field}
			value={column.field}
			label={column?.label || null}
			checked={value ?? false}
			onChange={handleCheckbox}
			disabled={disabled}
		/>
	);
};
